import React from "react";

const HeroSection = ({ title, image }) => {
  return (
    <section className="w-full flex-col justify-start items-center bg-white text-[#f7c612]">
      <div className="text-center mb-20">
        <h1 className="text-4xl md:text-6xl font-bold mt-40 mb-6 mx-4 sm:mx-8">
          Stay Connected, Build Networks
        </h1>
        <p className="text-lg md:text-2xl mb-16">
          Join the Alumnus as they share <br /> their journeys, profiles, and experiences creating opportunities together.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <a
            href="/alumni/login"
            className="border border-green-500 hover:bg-green-500 text-black py-3 px-6 transition-all duration-300"
          >
            Login/Signup 
          </a>
         
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
